import React from 'react';
import './Page5.css';

const Page5 = () => {
  return (
    <div className="page5-section">
      <h2 className="why-us-heading">Why SpatialCT?</h2>
      <div className='underline'></div>
      <div className="why-us-box">
        <h3>Proven Expertise</h3>
      
      </div>  <p className='para1'>25+ years in gaming, 3D graphics, and XR technologies.</p>
      <p className='para2'>With over <b>25 years of hands-on experience</b> in gaming, 3D graphics, and extended reality (XR) technologies, our leadership and core team bring a rare blend of creative innovation and technical mastery. We've worked across industries and platforms—building immersive applications long before XR became mainstream. This deep-rooted knowledge ensures that our clients benefit from tried-and-tested methods alongside modern advancements.
    </p>
    <hr />
      <div className="why-us-box">
        <h3>Innovative & Practical Solutions</h3>
        
      </div >
      <p className='para1'>From XR workshops to custom metaverse platforms..</p>
      <p className='para2'>We don't just follow trends—we create <b> meaningful XR experiences that solve real-world problems</b>. From industry-relevant XR workshops and immersive skill training simulators to bespoke metaverse platforms tailored for enterprise and public sector use, our solutions are crafted to be both visionary and executable. Every product and service we offer is designed with clarity, usability, and tangible outcomes in mind.
       
    </p>
    <hr />
      <div className="why-us-box">
        <h3>End-to-End Offerings</h3>
      </div>
      <p className='para1'>Strategy, development, deployment, and training.</p>
      <p className='para2'>At SpatialCT, we support the entire XR journey. Whether you are just exploring spatial computing or ready to scale immersive solutions across your organization, we offer a full-stack service—from <b> needs assessment and technology strategy to custom development, integration, deployment, and user training</b>. Our team ensures that the technology not only works but is also embraced and adopted effectively.
    </p>
    <hr />
      <div className="why-us-box">
        <h3>Scalable, Modular Approach</h3>
      </div>
      <p className='para1'>Services designed to grow with your needs.</p>
      <p className='para2'>We understand that different clients have different goals, budgets, and growth trajectories. That’s why <b> our offerings are modular, flexible, and scalable</b>—enabling   you to start small and expand as your vision grows. Whether it's a one-time workshop, a multi-user industrial walkthrough, or a fully-fledged spatial collaboration platform, our solutions adapt to your pace.
    </p>
    <hr />
      <div className="why-us-box">
        <h3>Future-Ready Vision</h3>
      </div>
      <p className='para1'>Building the next-gen of AI-driven spatial computing tools.</p>
      <p className='para2'>SpatialCT is not just responding to the present—we are  helping define the future. Our roadmap includes the development of next-generation AI-driven spatial computing tools <b> that will power tomorrow’s immersive experiences </b>. We are committed to continuous innovation, ensuring that our clients stay ahead of the curve in this rapidly evolving tech landscape.</p>
    </div>
  );
};

export default Page5;
